import React from 'react'

/**
 * Componente AmarsiLogo
 * 
 * Logotipo de Amarsi que acepta tamaños variables mediante props o className
 * 
 * @param {Object} props - Propiedades del componente
 * @param {string} props.width - Ancho del logo (ej: "24", "2rem", "100%")
 * @param {string} props.height - Alto del logo (ej: "24", "2rem", "100%")
 * @param {string} props.className - Clases CSS adicionales
 * @param {Object} props.rest - Propiedades adicionales para el SVG
 */
const AmarsiLogo = ({ width = "1em", height = "1em", className = "", ...rest }) => (
  <svg 
    {...rest} 
    xmlns="http://www.w3.org/2000/svg" 
    width={width} 
    height={height}
    className={className}
    viewBox="0 0 100 100"
    preserveAspectRatio="xMidYMid meet"
  >
    <g data-name="Grupo 74">
      <path fill="none" d="M0 0h100v100H0z" data-name="Rect\xE1ngulo 16" />
      <g data-name="Enmascarar grupo 2">
        <path
          fill="#da0037"
          d="M17.148 2.755c-3.613 7.948-7.2 19.537-8.171 26.4a89.663 89.663 0 0 0-.111 21.816 10.534 10.534 0 0 1-.111 4.752 33.348 33.348 0 0 0 .556 15.535c1.584 5.03 4.641 9.56 9.866 14.563a30.535 30.535 0 0 0 8.754 6.031c1.7.862 3.668 1.945 4.363 2.39a37.042 37.042 0 0 0 11.728 4.808 53.7 53.7 0 0 0 11.95 0A37.043 37.043 0 0 0 67.7 94.242c.695-.445 2.668-1.529 4.363-2.39a30.535 30.535 0 0 0 8.754-6.031c5.225-5 8.282-9.532 9.866-14.563a33.347 33.347 0 0 0 .556-15.535 10.534 10.534 0 0 1-.111-4.752 89.662 89.662 0 0 0-.111-21.816c-.973-6.864-4.558-18.453-8.171-26.4a8.854 8.854 0 0 0-1.167-2.14c-.361 0-7.7 7.67-9.449 9.866a58.322 58.322 0 0 0-9.032 15.563 17.146 17.146 0 0 1-1.39 3.141c-.278.306-.667.306-2.251 0-2.64-.5-16.48-.5-19.12 0-1.584.306-1.973.306-2.251 0a17.147 17.147 0 0 1-1.39-3.141 58.321 58.321 0 0 0-9.032-15.563C26.016 8.285 18.679.615 18.318.615a8.854 8.854 0 0 0-1.17 2.14Zm12.506 55.666c7.337 2.057 11.311 7.281 11.867 15.674.083 1.223.222 2.724.306 3.279l.111 1.056h-2.14a27.556 27.556 0 0 1-8.782-1.5 13.824 13.824 0 0 1-8.115-7.253 21 21 0 0 1-2-8.865l-.167-3.307 3.446.167a27.628 27.628 0 0 1 5.476.749Zm49.44 2.418a20.964 20.964 0 0 1-2 8.838 13.823 13.823 0 0 1-8.115 7.253 27.557 27.557 0 0 1-8.782 1.5h-2.14l.111-1.056c.083-.556.222-2.056.306-3.279.723-10.672 6.976-16.313 18.314-16.48l2.473-.028Z"
          data-name="Trazado 6"
        />
      </g>
    </g>
  </svg>
)
export default AmarsiLogo
